import { useEffect, useState } from "react";
import moment from "moment/moment";
import { getMobileOperatingSystem } from "../../components/utils";
import ClipLoader from "react-spinners/ClipLoader";
import { Link } from "react-router-dom";
import '../../OfferWall.css';
import { socket } from "../Containers/MainContainer";

export default function MainWallContainerPaidCashExclusive({ uid, first_page }) {
    const [selectedTab, setTab] = useState('available');
    const [visible, setVisible] = useState(false);
    const [visibleOS, setVisibleOS] = useState(false);
    const [selectedCat, setCat] = useState('all');
    const [selectedOS, setOS] = useState(['web', 'android', 'ios']);
    const [offers, setOffers] = useState(undefined);
    const [filterBy, setFilterBy] = useState(0);
    const [offersCompleted, setOffersCompleted] = useState(undefined);
    const [offersClicked, setOffersClicked] = useState(undefined);
    const [selectedOffer, setSeloffer] = useState(undefined);
    const [categories, setCategories] = useState(['all']);
    const [filtOff, setFiltOff] = useState(undefined);
    const [success, setSuccess] = useState(true);
    const [successMessage, setSuccessMessage] = useState('');
    const [searchQuery, setSearchQuery] = useState('');

    async function fetchOffers(type = "available") {
        setFiltOff(undefined);
        setOffers(undefined);
        setOffersClicked(undefined);
        setOffersCompleted(undefined);
        
        socket.emit('getPaidCashExlusive', {
            type,
            wall_id: 0
        });
        
        socket.on('getPaidCashExlusiveData', (data) => {
            if (data.success == true) {
                if (type == "available") {
                    setOffers(data.arrOffers);
                    setCategories(data.categories);
                    setFiltOff(data.arrOffers);
                } else if (type == "progress") {
                    setOffersClicked(data.arrClickedOffers);
                    setFiltOff(data.arrClickedOffers);
                } else {
                    setOffersCompleted(data.arrCompletedOffers);
                    setFiltOff(data.arrCompletedOffers);
                }
            } else {
                setSuccess(data.success);
                setSuccessMessage(data.message);
            }
        });
    }

    useEffect(() => {
        if (uid == undefined) {
            setSuccess(false);
            setSuccessMessage('UID is not set. Please contact the site owner to properly integrate the offerwall.');
        } else {
            fetchOffers();
        }
        
        return () => {
            socket.off('getPaidCashExlusiveData');
        };
    }, []);

    useEffect(() => {
        ModifyView(selectedTab);
    }, [selectedCat, selectedTab, selectedOS, filterBy, searchQuery]);

    function ModifyView(type = '') {
        let off = [];
        
        if (type === 'progress' && offersClicked) {
            off = [...offersClicked];
        } else if (type === 'completed' && offersCompleted) {
            off = [...offersCompleted];
        } else if (type === 'available' && offers) {
            off = offers.filter(offer => {
                // Filter by category
                if (selectedCat !== 'all' && !offer.category?.join(",").includes(selectedCat)) {
                    return false;
                }
                
                // Filter by OS
                const osList = [];
                if (offer.os?.includes("windows") || offer.os?.includes("desktop") || 
                    offer.os?.includes("macos") || offer.os?.includes("linux") || 
                    offer.os?.includes("web")) {
                    osList.push("web");
                }
                if (offer.os?.includes("ipad") || offer.os?.includes("ios") || 
                    offer.os?.includes("iphone") || offer.os?.includes("ipod")) {
                    osList.push("ios");
                }
                if (offer.os?.includes("android")) {
                    osList.push("android");
                }
                
                const hasMatchingOS = selectedOS.some(os => osList.includes(os)) || 
                                     offer.os?.includes("*");
                
                if (!hasMatchingOS) {
                    return false;
                }
                
                // Filter by search query
                if (searchQuery && !offer.name?.toLowerCase().includes(searchQuery.toLowerCase()) &&
                    !offer.description?.toLowerCase().includes(searchQuery.toLowerCase())) {
                    return false;
                }
                
                return true;
            });
            
            // Sort offers
            if (filterBy == 0) {
                off.sort((a, b) => {
                    const aVal = parseInt(a.c?.replace(",", "") || 0);
                    const bVal = parseInt(b.c?.replace(",", "") || 0);
                    return bVal - aVal;
                });
            } else if (filterBy == 2) {
                off.sort((a, b) => {
                    const aVal = parseInt(a.reward?.replace(",", "") || 0);
                    const bVal = parseInt(b.reward?.replace(",", "") || 0);
                    return bVal - aVal;
                });
            } else if (filterBy == 1) {
                off.sort((a, b) => {
                    const aVal = parseInt(a.reward?.replace(",", "") || 0);
                    const bVal = parseInt(b.reward?.replace(",", "") || 0);
                    return aVal - bVal;
                });
            }
        }
        
        setFiltOff(off);
    }

    function includesOS(offer) {
        const userAgent = window.navigator.userAgent;
        const os = getMobileOperatingSystem(userAgent);
        return os.some(o => offer.os?.toLowerCase().includes(o.toLowerCase()));
    }

    function handleOS(os) {
        setOS(prev => {
            if (prev.includes(os)) {
                if (prev.length > 1) {
                    return prev.filter(item => item !== os);
                }
                return prev;
            } else {
                return [...prev, os];
            }
        });
    }

    function handleOfferClick(offer) {
        if (selectedTab === 'progress' || !offer.credited) {
            const pc_t_id = [...Array(30)].map(() => Math.random().toString(36)[2]).join('') + 
                          (new Date().getTime() + '').substring(5, (new Date().getTime() + '').length - 1);
            
            socket.emit('userAction', {
                action: 'clicked_offer',
                id: offer.id,
                pc_t_id
            });
            
            window.open(
                offer.link?.replace('[pc_t_id]', pc_t_id),
                '_blank'
            );
        }
    }

    return (
        <div className="offerwall-container">
            {/* Device Filter Dialog */}
            {/* {visibleOS && (
                <div className="modal-overlay" onClick={() => setVisibleOS(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Device Filter</h3>
                            <button className="modal-close" onClick={() => setVisibleOS(false)}>×</button>
                        </div>
                        <div className="device-filter">
                            <button 
                                className={`device-filter-btn ${selectedOS.includes('web') ? 'active' : ''}`}
                                onClick={() => handleOS('web')}
                            >
                                <img src='/assets/img/icons/website.svg' alt="Web" />
                                <span>Web</span>
                            </button>
                            <button 
                                className={`device-filter-btn ${selectedOS.includes('android') ? 'active' : ''}`}
                                onClick={() => handleOS('android')}
                            >
                                <img src='/assets/img/icons/android.svg' alt="Android" />
                                <span>Android</span>
                            </button>
                            <button 
                                className={`device-filter-btn ${selectedOS.includes('ios') ? 'active' : ''}`}
                                onClick={() => handleOS('ios')}
                            >
                                <img src='/assets/img/icons/apple.svg' alt="iOS" />
                                <span>iOS</span>
                            </button>
                        </div>
                    </div>
                </div>
            )} */}

            {/* Offer Details Dialog */}
            {visible && selectedOffer && (
                <div className="modal-overlay" onClick={() => setVisible(false)}>
                    <div className="modal-content offer-details-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Offer Details</h3>
                            <button className="modal-close" onClick={() => setVisible(false)}>×</button>
                        </div>
                        <div className="offer-details-content">
                            <div className="offer-header">
                                <div className="offer-image">
                                    <img src={selectedOffer.image} alt={selectedOffer.name} />
                                </div>
                                <div className="offer-info">
                                    <h4>{selectedOffer.name}</h4>
                                    <p className="offer-description">{selectedOffer.description}</p>
                                </div>
                                <div className="offer-reward">
                                    <img src='/assets/img/icons/coins.svg' alt="Coins" />
                                    <div>
                                        <p className="reward-up-to">
                                            UP TO <s>{selectedOffer.oldReward}</s>
                                        </p>
                                        <p className="reward-amount">{selectedOffer.reward}</p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="offer-steps">
                                {selectedOffer.steps?.map((step, index) => (
                                    step.trim() && <p key={index} className="step">• {step}</p>
                                ))}
                            </div>
                            
                            {!includesOS(selectedOffer) && (
                                <div className="device-warning">
                                    <p>
                                        Looks like this offer is not suitable for this device.<br />
                                        Please scan the QR code with any of your {selectedOffer.os} devices.
                                    </p>
                                    <img 
                                        src={`https://util.paidcash.co/api/offer/qr?uid=${uid}&offerid=${selectedOffer.id}`} 
                                        alt="QR Code"
                                    />
                                </div>
                            )}
                            
                            <div className="offer-terms">
                                <ul>
                                    <li>The advertiser decides whether or not you completed the offer and notifies us whether or not you should receive the incentive.</li>
                                    <li>Offers must be started and completed on the same device and in the same browser tab where the link opens. While working on the offers, you must keep your device connected to the internet at all times.</li>
                                </ul>
                            </div>
                            
                            {includesOS(selectedOffer) && (
                                <button 
                                    className="start-offer-btn"
                                    onClick={() => handleOfferClick(selectedOffer)}
                                >
                                    {selectedTab === "progress" ? "Retry" : "Start The Offer"}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Header */}
            <header className="offerwall-header">
                <div className="header-top">
                    <h1>Offers</h1>
                    {/* <div className="header-actions">
                        <button 
                            className="device-filter-trigger"
                            onClick={() => setVisibleOS(true)}
                        >
                            <img src='/assets/img/icons/device.svg' alt="Filter by device" />
                        </button>
                    </div> */}
                </div>

                {/* Tabs */}
                {/* <div className="tabs">
                    <button 
                        className={`tab ${selectedTab === 'available' ? 'active' : ''}`}
                        onClick={() => setTab('available')}
                    >
                        Available Offers
                    </button>
                    <button 
                        className={`tab ${selectedTab === 'progress' ? 'active' : ''}`}
                        onClick={() => setTab('progress')}
                    >
                        In Progress
                    </button>
                    <button 
                        className={`tab ${selectedTab === 'completed' ? 'active' : ''}`}
                        onClick={() => setTab('completed')}
                    >
                        Completed
                    </button>
                </div> */}

                {/* Filters */}
                {/* {selectedTab === 'available' && (
                    <div className="filters-section">
                        <div className="search-box">
                            <input
                                type="text"
                                placeholder="Search offers..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <img src='/assets/img/icons/search.svg' alt="Search" />
                        </div>
                        
                        <div className="filter-row">
                            <div className="category-filter">
                                {categories.map((category) => (
                                    <button
                                        key={category}
                                        className={`category-btn ${category.toLowerCase() === selectedCat ? 'active' : ''}`}
                                        onClick={() => setCat(category.toLowerCase())}
                                    >
                                        {category}
                                    </button>
                                ))}
                            </div>
                            
                            <select 
                                className="sort-select"
                                value={filterBy}
                                onChange={(e) => setFilterBy(Number(e.target.value))}
                            >
                                <option value={0}>Selected For You</option>
                                <option value={1}>Low to High</option>
                                <option value={2}>High to Low</option>
                            </select>
                        </div>
                    </div>
                )} */}

                {/* {selectedTab === 'progress' && (
                    <div className="progress-info">
                        <p>Your user id: <strong>{first_page}_{uid}</strong></p>
                        <p>
                            Contact us at{' '}
                            <a href={`mailto:support@sumpixmedia.com?Subject=[WALL] OfferWall Support &Body=Please state your problem here:%0d%0a%0d%0a______________________%0d%0a**DO NOT REMOVE THIS**%0d%0a${first_page}_${uid}`}>
                                support@sumpixmedia.com
                            </a>{' '}
                            if you need help
                        </p>
                    </div>
                )} */}
            </header>

            {/* Main Content */}
            <main className="offerwall-main">
                {!success ? (
                    <div className="error-message">
                        <h2>{successMessage}</h2>
                    </div>
                ) : filtOff === undefined ? (
                    <div className="loading-state">
                        <h2>PaidCash Exclusive</h2>
                        <ClipLoader
                            color='#000'
                            loading={true}
                            size={50}
                            aria-label="Loading Spinner"
                        />
                    </div>
                ) : filtOff.length === 0 ? (
                    <div className="empty-state">
                        <h3>No offers found</h3>
                        <p>Try changing your filters or check back later for new offers.</p>
                    </div>
                ) : (
                    <div className="offers-grid">
                        {filtOff.map((offer) => (
                            <div key={offer.id} className="offer-card">
                                <div className="offer-card-content" onClick={() => {
                                    setSeloffer(offer);
                                    setVisible(true);
                                }}>
                                    <div className="offer-card-image">
                                        <img src={offer.image} alt={offer.name} />
                                    </div>
                                    <div className="offer-card-details">
                                        <h4>{offer.name}</h4>
                                        <p className="offer-card-description">
                                            {offer.description?.length > 60 
                                                ? `${offer.description.substring(0, 60)}...` 
                                                : offer.description}
                                        </p>
                                    </div>
                                    <div className="reward-display">
                                            <img src='/assets/img/icons/coins.svg' alt="Coins" />
                                            <div>
                                                <span className="reward-label">
                                                    UP TO <s>{offer.oldReward}</s>
                                                </span>
                                                <span className="reward-value">{offer.reward}</span>
                                            </div>
                                        </div>
                                </div>
                                
                            </div>
                        ))}
                    </div>
                )}
            </main>
        </div>
    );
}